import TreeView from "./TreeView"
import { useKnowledgeBase } from "./hooks"
import { useMemo } from "react"
import { useStore } from "@/store"
import { useTranslation } from "react-i18next"

/**
 * FoldersTab - Displays knowledge base folders
 */
const FoldersTab = () => {
  const { t } = useTranslation()
  const [workspaces] = useStore((s) => [s.workspaces])
  const joinedWorkspaces = useMemo(
    () => (workspaces || []).filter((w) => w.isJoined),
    [workspaces]
  )

  const kb = useKnowledgeBase()

  return (
    <div className="flex flex-col gap-6">
      {joinedWorkspaces.length === 0 ? (
        <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4">
          <div className="text-sm text-slate-700 dark:text-slate-300">
            {t("knowledgeBase.sections.folders.noWorkspace")}
          </div>
        </div>
      ) : (
        <TreeView kb={kb} />
      )}
    </div>
  )
}

export default FoldersTab
